import React from 'react';

import config from '../../config';
import { twitterPageURL } from '../../util/urlHelpers';
import {
  LayoutSingleColumn,
  LayoutWrapperTopbar,
  LayoutWrapperMain,
  LayoutWrapperFooter,
  Footer,
  ExternalLink,
} from '../../components';
import StaticPage from '../../containers/StaticPage/StaticPage';
import TopbarContainer from '../../containers/TopbarContainer/TopbarContainer';
import AboutUsPic from './images/Our-story.png';

import css from './AboutPage.module.css';

const AboutPage = () => {
  const { siteTwitterHandle, siteFacebookPage } = config;
  const siteTwitterPage = twitterPageURL(siteTwitterHandle);

  return (
    <StaticPage
      title="About Us"
      schema={{
        '@context': 'http://schema.org',
        '@type': 'AboutPage',
        description: 'About Rotate',
        name: 'About page',
      }}
    >
      <LayoutSingleColumn>
        <LayoutWrapperTopbar>
          <TopbarContainer />
        </LayoutWrapperTopbar>

        <LayoutWrapperMain className={css.staticPageWrapper}>
          <div className={css.wrapper}>
            <h1 className={css.titleMobile}>Our Story</h1>
            <div className={css.row}>
              <div className={css.imageContainer}>
                <img src={AboutUsPic} className={css.image} />
              </div>

              <div className={css.rowText}>
                <h1 className={css.titleDesktop}>Our Story</h1>
                <p>ROTATE exists to bring together like-minded New Zealanders to buy and sell furniture and interiors.</p>
                <p style={{ marginTop: 18 }}>Our platform rotates in two ways:</p>
                <ul className={css.list}>
                  <li>Explore, shop, and add designer and vintage pieces to your home</li>
                  <li>Or list, sell, and move your once-loved pieces onto another</li>
                </ul>
                <p>Together, the old can rotate into new.</p>
                <p style={{ marginTop: 18 }}>
                  Behind ROTATE are founders Maxine and Charlotte. A turning point
                  came when trying to source timeless, well-made pieces for their
                  own homes. Finding them took time and effort. And when it came
                  to selling, it was just as challenging to connect with the right buyers.
                  They needed a space that did both.
                </p>
                <p style={{ marginTop: 18 }}>
                  That space is ROTATE — a curated marketplace built for people
                  who value design, craftsmanship and longevity.
                </p>
              </div>
            </div>
          </div>
        </LayoutWrapperMain>
        <LayoutWrapperFooter>
          <Footer />
        </LayoutWrapperFooter>
      </LayoutSingleColumn>
    </StaticPage>
  );
};

export default AboutPage;
